import Auth from 'live/services/authorization'

export function isAdmin() {
    return Auth.Permission.ADMIN || Auth.Permission.SUPER_USER
}

export function canAccessPSR() {
    return !!(isAdmin() || Auth.Permission.POST_STAGE_REPORT_ACCESS)
}
